import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Member } from 'react-wot-bootstrap'

export const PERIOD_FILTER_CAPTION = (
    <FormattedMessage
        id="clanmanagement.period.filter.caption"
        defaultMessage="Период:"
    />
)

export const PERIOD_28_DAYS = (
    <FormattedMessage
        id="clanmanagement.period.28_days"
        defaultMessage="28 д."
    />
)

export const PERIOD_7_DAYS = (
    <FormattedMessage
        id="clanmanagement.period.7_days"
        defaultMessage="7 д."
    />
)

export const PERIOD_1_DAY = (
    <FormattedMessage
        id="clanmanagement.period.1_day"
        defaultMessage="1 д."
    />
)

export const PERIOD_ALL_TIME = (
    <FormattedMessage
        id="clanmanagement.period.all_time"
        defaultMessage="Всё время"
    />
)

export const BLOCK_TYPES_CLAN_MODES = (
    <FormattedMessage
        id="clanmanagement.block_types.clan_modes"
        defaultMessage="Клановые режимы"
    />
)

export const BLOCK_TYPES_STATISTICS = (
    <FormattedMessage
        id="clanmanagement.block_types.statistics"
        defaultMessage="Статистика"
    />
)

export const STATISTICS_BATTLE_TYPES_RANDOM = (
    <FormattedMessage
        id="clanmanagement.statistics_battle_types.random"
        defaultMessage="Случайный"
    />
)

export const STATISTICS_BATTLE_TYPES_RANKED = (
    <FormattedMessage
        id="clanmanagement.statistics_battle_types.ranked"
        defaultMessage="Ранговый"
    />
)

export const STATISTICS_BATTLE_TYPES_TEAM = (
    <FormattedMessage
        id="clanmanagement.statistics_battle_types.team"
        defaultMessage="Командный"
    />
)

export const STATISTICS_BATTLE_TYPES_SKIRMISHES = (
    <FormattedMessage
        id="clanmanagement.statistics_battle_types.skirmishes"
        defaultMessage="Вылазка"
    />
)

export const STATISTICS_BATTLE_TYPES_FORT = (
    <FormattedMessage
        id="clanmanagement.statistics_battle_types.fort"
        defaultMessage="Бои в Наступлениях"
    />
)

export const STATISTICS_BATTLE_GLOBAL_MAP = (
    <FormattedMessage
        id="clanmanagement.statistics_battle_types.global_map"
        defaultMessage="Глобальная карта"
    />
)

export const STATISTICS_BATTLE_TYPE_SELECT_CAPTION = (
    <FormattedMessage
        id="clanmanagement.statistics_battle_types_select.caption"
        defaultMessage="Режим боя:"
    />
)

export const TITLE_STAFF = (
    <FormattedMessage
        id="clanmanagement.title.staff"
        defaultMessage="Личный состав"
    />
)

export const CAPTION_ABOUT_INDICATORS = (
    <FormattedMessage
        id="clanmanagement.title.about_indicators"
        defaultMessage="О показателях"
    />
)

const emptyPlaceholder = '--'
export const MEMBERS_ONLINE = (membersOnline, membersTotal) => (
    <FormattedMessage
        id='clan_management.members'
        defaultMessage='Игроков в сети: {membersOnline}/{membersTotal}'
        values={{
            membersOnline: <Member name={membersOnline || emptyPlaceholder} status='online' />,
            membersTotal: membersTotal || emptyPlaceholder,
        }}
    />
)

export const TREASURY = (
    <FormattedMessage
        id="treasury_subtitle"
        defaultMessage="Казна клана:"
    />
)

export const EARNED_RESOURCE_TOOLTIP_TITLE = (
    <FormattedMessage
        id="clanmanagement.tooltips.earned_resource_header"
        defaultMessage="Промресурс для клана"
    />
)



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/ClanManagement/translations.js